import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, OnInit, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { LocationDTO } from "src/app/features/locations-map/models/LocationDTO";
@Injectable({
  providedIn: "root",
})
export class VirtualLocationsAPIService implements IApiBase{
  
  private configUrl = "";
  public Result;
  httpHeaders: HttpHeaders = new HttpHeaders();
  
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  getLocationCategoryChilds(parentIdentifier: string): any {
    console.log("/api/Location/GetLocationCategoryChilds/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/GetLocationCategoryChilds?parentIdentifier=" + parentIdentifier,
      {}
    );
  }
  getChilds(parentIdentifier: string, idLocationCategoryChild: number): any {
    console.log("/api/Location/postValidateIdentifiers/", parentIdentifier, idLocationCategoryChild);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/GetRouteSheet?parentIdentifier=" + parentIdentifier + "&idLocationCategory=" + idLocationCategoryChild, {}
    );
  }
  getChildrenFilteredByIdentifier(parentIdentifier: string, searchValue: string, childCategory: number): any {
    console.log("/api/Location/postValidateIdentifiers/", parentIdentifier, searchValue, childCategory);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/GetChildrenFilteredByIdentifier?parentIdentifier=" + parentIdentifier + "&searchValue=" + searchValue + "&childCategory=" + childCategory, {}
    );
  }
  
}
